import React from 'react';
import { Route } from 'react-router-dom';
import { LinearProgress } from '@mui/material';
import { NavBarContent } from 'feature/nav/NavBar';
import DocumentTabs from '../DocumentTabs';
import useStyles from './Document.styles';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { first, get } from 'global/lib/lodash';
import { Transform, Includes } from '../DocumentList';

export default function Document(props) {
  const { match } = props;
  const classes = useStyles();

  const edition_id = get(props, 'editionId', get(match, 'params.library'));
  const classification_id = get(props, 'classificationId', get(match, 'params.document'));

  const edition = useRetrieveData({ url: `/editions/${edition_id}` }, { build: ['editions'], params: { include: 'scorecards,scorecards.checklists' }, transformData: (d) => first(d) });
  const { data, loading, update } = useRetrieveData(
    { url: `/edition-documents` },
    {
      useLangFilter: true,
      build: ['editionDocuments'],
      params: {
        include: Includes.join(','),
        filter: { classification_id, edition_id },
        editMode: 1,
      },
      useEffect: true,
      transformData: Transform,
    }
  );

  return (
    <div className={classes.content}>
      <NavBarContent pageTitle={loading ? 'Loading...' : get(data, '0.document.name', '')} link={'library/' + edition_id} closeProps={props.closeProps} />
      <Route
        exact
        path={`/library/:library/document/:document`}
        render={(p) => <DocumentTabs {...p} edition={edition.data} documents={data} update={update} userCanEdit={get(edition, 'data.userCanEdit', false)} />}
      />
      {props.isModal && <DocumentTabs {...props} documents={data} edition={edition.data} update={update} canEdit={get(edition, 'data.userCanEdit', false)} />}
      {loading && <LinearProgress />}
    </div>
  );
}
